// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"task-add-1"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C13.3633 2 14.6629 2.27281 15.8472 2.76682M22 4.5L12 14.5L7.5 10","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M19 16V19M19 19V22M19 19H16M19 19H22","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TaskAdd1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'task-add-1',
    ref,
    icon: element,
  },
));

TaskAdd1Icon.displayName = 'TaskAdd1Icon';

export default TaskAdd1Icon;
